import React from 'react';
import {Card, CardActions, CardContent} from "@mui/material";
import {CardData, CardTitle} from "@atttomyx/react-components";
import {datetime} from "@atttomyx/shared-utils";

const TemplateCard = (props) => {
    const { template, filters, children } = props;

    return <Card className="template-card" raised={true}>
        <CardContent>
            <CardTitle>
                {template.name}
            </CardTitle>
            <CardData
                filters={filters}
                data={template}
                keyToMetadata={{
                    order: {
                        title: "Index",
                    },
                    created: {
                        title: "Created",
                        formatter: datetime.getFullDateAndTime,
                    },
                    updated: {
                        title: "Updated",
                        formatter: datetime.getFullDateAndTime,
                    },
                }}
            />
        </CardContent>
        <CardActions disableSpacing={true}>
            {children}
        </CardActions>
    </Card>
}

export default TemplateCard;
